import { ArrayLoading } from '@/store/types'

import { loading, none } from '@/store/constants'
import {
  ActiveDocumentFolder, DocumentFolder, Document, DocumentUsage, ActiveDocument,
} from './types'

import { blankEditBase, active } from '@/store/editor/constants'

import _ from 'lodash'

// TODO: Permission for each role by default!
export const blankDocumentFolder: DocumentFolder = _.merge({
  FolderId: -1,
  FolderName: '',
  ChildFolders: [],
  Documents: [],
}, blankEditBase)

export const loadingDocumentFolder: ArrayLoading<DocumentFolder> = _.assign([], blankDocumentFolder, loading)

export const noneDocumentFolder: DocumentFolder = _.assign({}, blankDocumentFolder, none)

export const activeDocumentFolderNone: ActiveDocumentFolder = _.assign({}, blankDocumentFolder, active, none)

export const blankDocument: Document = _.assign({ DocumentId: -1, DocumentName: '', FullPath: '', ContentType: '' }, blankEditBase)

export const noneDocument: Document = _.assign({}, blankDocument, none)

export const activeDocumentNone: ActiveDocument = _.assign({}, noneDocument, active, none)

export const blankDocumentUsage: DocumentUsage = _.assign({ DocumentId: -1, Path: '', DocumentPath: '', Products: [], Categories: [], SectionDocuments: [], Sites: [] }, blankEditBase)
